export let myGlobal = process.env.REACT_APP_API_Global
export let api="https://api.hariomtextiles.co.in";
//export let api=process.env.REACT_APP_API_URL;

//export let api="http://localhost:1350/APIADVENT";